import { useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';

function getVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export function useChartColors() {
  const { theme } = useTheme();

  return useMemo(() => ({
    primary:       getVar('--chart-primary'),
    secondary:     getVar('--chart-secondary'),
    success:       getVar('--chart-success'),
    warning:       getVar('--chart-warning'),
    purple:        getVar('--chart-purple'),
    pink:          getVar('--chart-pink'),
    cyan:          getVar('--chart-cyan'),
    lime:          getVar('--chart-lime'),
    grid:          getVar('--chart-grid'),
    axis:          getVar('--chart-axis'),
    tooltipBg:     getVar('--chart-tooltip-bg'),
    tooltipBorder: getVar('--chart-tooltip-border'),
    text:          getVar('--chart-text'),
    heatmapRgb:    getVar('--heatmap-color'),
  }), [theme]);
}

export function useChartPalette(): string[] {
  const c = useChartColors();
  return useMemo(
    () => [c.primary, c.secondary, c.success, c.warning, c.purple, c.pink, c.cyan, c.lime],
    [c.primary, c.secondary, c.success, c.warning, c.purple, c.pink, c.cyan, c.lime]
  );
}
